// extracted by mini-css-extract-plugin
export var root = "Line-module--root--4i9Zj";
export var txt = "Line-module--txt--zj4NT";
export var line = "Line-module--line--3QBuE";
export var flexbox = "Line-module--flexbox--1pYEL";